import React, { useState } from "react";
import {
  Box,
  FormLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  TextareaAutosize,
  Paper,
  Chip,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import "../../css/Prompts.css"; // Import the new CSS file
import { useDispatch, useSelector } from "react-redux";
import {
  saveFormDetails
} from "../../redux/slices/CreateAgentSlice";

const Prompts = ({ error, setErrors }) => {
  const [open, setOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState({});
  const dispatch = useDispatch();
  const {
    formDetails
  } = useSelector((state) => state.CreateAgentSlice);

  const handleClose = () => {
    setOpen(false);
  };

  const handleTextInput = (value, key) => {
    dispatch(
      saveFormDetails({ key, value: value?.target?.value })
    );
    setErrors((prev) => ({
      ...prev,
      [key]: "",
    }));
  };

  const handleAutoResize = (e) => {
    const textarea = e.target;
    textarea.style.height = 'auto';
    textarea.style.height = Math.max(80, textarea.scrollHeight) + 'px';
  };

  return (
    <div>


      {/* System Instruction Section */}
      <Box className="prompts-section">
        <Box className="prompts-header">
          <FormLabel className="prompts-label">
            System Instruction
            <Tooltip title="Define the AI agent's role, expertise, and behavior guidelines">
              <InfoIcon className="prompts-info-icon" />
            </Tooltip>
          </FormLabel>
          <Chip
            label="Required"
            size="small"
            className="prompts-required-chip"
          />
        </Box>

        <Box sx={{ width: '95%', display: 'flex', flexDirection: 'column' }}>
          <textarea
            className={`prompts-textarea ${error.system_instruction ? 'error' : ''}`}
            value={formDetails?.system_instruction || ''}
            onChange={(e) => {
              handleTextInput(e, 'system_instruction');
              handleAutoResize(e);
            }}
            onInput={handleAutoResize}
            placeholder="Enter detailed instructions for the AI agent's behavior, role, and expertise. For example: 'You are a tax document extraction expert specializing in IRS Form W-2...'"
            style={{ width: '100%', minWidth: '100%' }}
          />

          {error.system_instruction && (
            <Typography className="prompts-error">
              <span className="prompts-error-icon">⚠</span>
              {error.system_instruction}
            </Typography>
          )}
        </Box>
      </Box>

      {/* Output Instruction Section */}
      <Box className="prompts-section">
        <Box className="prompts-header">
          <FormLabel className="prompts-label">
            Output Instruction
            <Tooltip title="Define the expected format and structure of the AI agent's output">
              <InfoIcon className="prompts-info-icon" />
            </Tooltip>
          </FormLabel>
          <Chip
            label="Required"
            size="small"
            className="prompts-required-chip"
          />
        </Box>

        <Box sx={{ width: '95%', display: 'flex', flexDirection: 'column' }}>
          <textarea
            className={`prompts-textarea ${error.output_instruction ? 'error' : ''}`}
            value={formDetails?.output_instruction || ''}
            onChange={(e) => {
              handleTextInput(e, 'output_instruction');
              handleAutoResize(e);
            }}
            onInput={handleAutoResize}
            placeholder="Specify the output format, structure, and any specific requirements. For example: 'Always return the extracted data as a single JSON object with the keys...'"
            style={{ width: '100%', minWidth: '100%' }}
          />

          {error.output_instruction && (
            <Typography className="prompts-error">
              <span className="prompts-error-icon">⚠</span>
              {error.output_instruction}
            </Typography>
          )}
        </Box>
      </Box>



      {/* Popup Dialog */}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h6">{popupMessage?.id}</Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
            {popupMessage?.message}
          </Typography>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Prompts;
